// src/router/index.js
import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import DataTable from '../components/DataTable.vue';
import DataTableTranslator from '../components/DataTableTranslator.vue';
import axios from 'axios'; // axios import 추가

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/login', // 기본 경로를 로그인 페이지로 리디렉션
  },
  {
    path: '/DataTable',
    name: 'DataTable',
    component: DataTable,
    meta: { requiresAuth: true } // 로그인 필요
  },
  {
    path: '/DataTableTranslator',
    name: 'DataTableTranslator',
    component: DataTableTranslator,
    meta: { requiresAuth: true } // 로그인 필요
  },
  {
    path: '/login',
    name: 'Login',
    beforeEnter: async (to, from, next) => {
      const sessionId = to.query.session_id;
      const userEmail = to.query.user_email;
  
      // sessionId와 userEmail이 없으면 그냥 다음으로 넘어감
      if (!sessionId || !userEmail) {
        next(); // 로그인 페이지로 계속 이동
        return;
      }
  
      // API 요청을 통해 auth 정보 가져오기
      try {
        const payload = {
          user_email: userEmail,
          token: sessionId // session_id를 token으로 사용
        };
  
        const response = await axios.post('https://api.da.kcpglob.com/api/common/kocowa/sgw/validate_token', payload, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
  
        // 인증 유효성 체크
        if (response.data.valid) {
          let copyAuth = response.data.auth;
  
          if (copyAuth === null) {
            copyAuth = 'MASTER';
          }

          // Vuex store에 로그인 정보 저장
          store.dispatch('login', { email: userEmail, token: sessionId, auth: copyAuth });
  
          // auth 값에 따라 라우팅 처리
          if (copyAuth === 'MASTER') {
            next({ name: 'DataTable' });
          } else if (['PORTUGUESE', 'SPANISH', 'VIETNAMESE', 'CHINESE'].includes(copyAuth)) {
            next({ name: 'DataTableTranslator' });
          } else {
            console.log('Invalid auth:', copyAuth); // 유효하지 않은 auth 로그
            next(); // 유효하지 않은 auth인 경우 그냥 다음으로 진행
          }
        } else {
          console.log('Invalid response:', response.data); // 유효하지 않은 응답 로그
          next(); // 유효하지 않은 인증 정보
        }
      } catch (error) {
        console.error('Error during login:', error);
        next(); // 에러 발생 시 다음으로 진행
      }
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
});

router.beforeEach((to, from, next) => {

  // 1. 로그인 여부 확인
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      console.log('Redirecting to Login...');
      next({ name: 'Login' });
    } else {
      next(); // 인증된 경우 다음으로 진행
    }
  } else {
    next(); // 인증이 필요 없는 경로일 경우 계속 진행
  }
});

export default router;
